import { render, staticRenderFns } from "./SubIndex.vue?vue&type=template&id=47c8ad94&scoped=true&"
import script from "./SubIndex.vue?vue&type=script&lang=js&"
export * from "./SubIndex.vue?vue&type=script&lang=js&"
import style0 from "./SubIndex.vue?vue&type=style&index=0&id=47c8ad94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8ad94",
  null
  
)

export default component.exports